import Amplify from './amplify';
import Websocket from './websocket';
import api from './api';

export default {
  amplify: Amplify,
  websocket: Websocket,
  api
};